var twoColSecAdvance = (function() {
  function init() {
    uiBindings();
  }

  var uiBindings = function() {

    // Main Block
    var twoColSecAdvanceParent = document.querySelectorAll('.advance-two-col');

    // Media Queries
    var mediaQueryMax = window.matchMedia('(max-width: 979px)');
    var mediaQueryMin = window.matchMedia('(min-width: 980px)');

    for (var i = 0; i < twoColSecAdvanceParent.length; i++) {

      // Swipe Testimonial Block below 980 resolution
      if(twoColSecAdvanceParent[i].querySelector('.advance-two-col__testimonial-block')) {
        var twoColSecAdvanceTestimonial = twoColSecAdvanceParent[i].querySelector('.advance-two-col__testimonial-block');
        var twoColSecAdvanceMainBlock = twoColSecAdvanceParent[i].querySelector('.advance-two-col__main-block');
        
        if (mediaQueryMax.matches) {
          twoColSecAdvanceMainBlock.parentNode.insertBefore(twoColSecAdvanceTestimonial, twoColSecAdvanceMainBlock.nextSibling);
        }
      }

      // Swipe Image left inside Block above 980 resolution
      if(twoColSecAdvanceParent[i].classList.contains('advance-two-col__img-left')) {
        var currentBlock1 = twoColSecAdvanceParent[i].querySelector('.advance-two-col__block1');
        var currentBlock2 = twoColSecAdvanceParent[i].querySelector('.advance-two-col__block2');
        
        if (mediaQueryMin.matches) {
          currentBlock2.parentNode.insertBefore(currentBlock1, currentBlock2.nextSibling);
        }
      }
        
      // Swipe Testimonial block below image above 980 resolution
      if(twoColSecAdvanceParent[i].classList.contains('advance-two-col__img-bottom')) {
        var twoColSecAdvanceTestimonial = twoColSecAdvanceParent[i].querySelector('.advance-two-col__testimonial-block');
        var twoColSecAdvanceMainBlock = twoColSecAdvanceParent[i].querySelector('.advance-two-col__main-block');
        
        if (mediaQueryMin.matches) {
          if (twoColSecAdvanceTestimonial) {
            twoColSecAdvanceMainBlock.parentNode.insertBefore(twoColSecAdvanceTestimonial, twoColSecAdvanceMainBlock.nextSibling);
          }
        }
      }
    
    }    

    // Calculate user scroll
    var newNode = document.createElement('div'),
    body = document.getElementsByTagName('body')[0];
    newNode.className = 'header-event-scroll';
    body.prepend(newNode);
    document.getElementsByClassName('header-event-scroll')[0].setAttribute("data-scroll-group", "event-group");
    var secElement = document.getElementsByClassName('animation-section'),
    i = 1,
    eventScroll = {};
    Array.prototype.forEach.call(secElement, function (singleSecElement) {
      singleSecElement.setAttribute("data-event-group", "eventScroll" + i);
      eventScroll["eventScroll" + i] = true;
      i++;
    });
    
    function querySelectorArray(query, root){
      return Array.prototype.slice.call((root || document).querySelectorAll(query));
    }

    var headers = querySelectorArray('[data-scroll-group]');
    headers.forEach(function(header){
      var group = header.getAttribute('data-scroll-group');
      sections = querySelectorArray('[data-' + group + ']'),
      window.addEventListener('scroll', function(){
        var lastSection = false;
        sections.forEach(function(section){
          var offset = section.getBoundingClientRect();
          if(offset.top < 0 && offset.top > -offset.height) lastSection = section.getAttribute('data-' + group + '');
        });
        // Apply the class to your header
        header.className = lastSection || '';

        if(eventScroll[lastSection] && lastSection){
          eventScroll[lastSection] = false;
          var locationName = '';
          switch (lastSection) {
            case 'eventScroll1':
              locationName = "HeroUnitSection";
              break;
            case 'eventScroll2':
              locationName = "FeaturesSection";
              break;
            case 'eventScroll3':
              locationName = "FrameworksSection";
              break;
            case 'eventScroll4':
              locationName = "ParallelExecutionSection";
              break;
            case 'eventScroll5':
              locationName = "CoverageSection";
              break;
            case 'eventScroll6':
              locationName = "CloudInfrastructureSection";
              break;
            case 'eventScroll7':
              locationName = "TestReportingSection";
              break;
            case 'eventScroll8':
              locationName = "ReliabilitySection";
              break;
            case 'eventScroll9':
              locationName = "GoalsSection";
              break;
            default:
              locationName = "AutomateLandingPageSections";
          }

          WebEventTracker.logEvent(EDS.webEvents, "ScrolledOnPage", {
            Page : '/automate',
            Section : locationName
          });
        }
      })
    });

    // Enable tooltip on tab focus
    var tooltipContainerElem = document.querySelectorAll('.advance-two-col__logo-section-child--hover a'),
      bFocus = bHover = false;
    
    if (tooltipContainerElem.length) {
      for (var i = 0; i < tooltipContainerElem.length; i++) {
        tooltipContainerElem[i].addEventListener('focus', tooltipFocusEventListener);
        tooltipContainerElem[i].addEventListener('keydown', tooltipkeydownEventListener);
        tooltipContainerElem[i].addEventListener('mouseenter', tooltipMouseOverEventListener);
        tooltipContainerElem[i].addEventListener('mouseout', tooltipMouseOutEventListener);
        tooltipContainerElem[i].addEventListener('blur', tooltipBlurEventListener);
      }

      function tooltipkeydownEventListener(e) {
        if (e.key == 'Escape' && !bHover) {
          var elem = e.target;
          elem.nextElementSibling.style.display = 'none';
          return false;
        }
        return true;
      }
  
      function tooltipFocusEventListener(e) {
        var elem = e.target;
        bFocus = true;
        elem.nextElementSibling.style.display = 'block';
        return false;
      }

      function tooltipBlurEventListener(e) {
        var elem = e.target;
        bFocus = false;
        if (!bHover) {
          elem.nextElementSibling.style.display = 'none';
        }
        return false;
      }

      function tooltipMouseOverEventListener(e) {
        var elem = e.target;
        bHover = true;
        elem.nextElementSibling.style.display = 'block';
        return false;
      }

      function tooltipMouseOutEventListener(e) {
        var elem = e.target;
        bHover = false;
        (bFocus = true) ? bFocus = false : null;
        if (!bFocus && elem.parentElement.classList.contains('advance-two-col__logo-section-link')) {
          elem.parentElement.nextElementSibling.style.display = 'none';
        } else {
          elem.nextElementSibling.style.display = 'none';
        }
        return false;
      }
    }
  };
  init();
})();